export default __webpack_public_path__ + "static/pengo-4ed0eebf78cddee55b1f7efdfd0d9239.jpeg";